export default __webpack_public_path__ + "static/media/tashkent1.53f687f6.jpg";